import { mergeRefs } from '@react-aria/utils'
import { forwardRef } from 'react'
import type { ListProps } from 'react-virtuoso'

import type { VirtualListItem } from './Context'
import type Context from './Context'

const List = forwardRef(function <T extends VirtualListItem>(
  { context, ...props }: ListProps & { context?: Context<T> },
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { list } = context ?? {}
  const mergedRefs = list?.ref ? mergeRefs(ref, list?.ref) : ref

  return (
    <div
      {...props}
      role="list"
      ref={mergedRefs as React.LegacyRef<HTMLDivElement>}
      {...list?.props}
    />
  )
})

export default List
